export const getMyProfile = '/user/my-profile';
export const updateProfile = '/user/';
